<template>
  <div class="error-page">
    <img src="@/assets/image/error/neterror@2x.png" class="error-img">
  </div>
</template>

<script>
export default {
  props: {
    'error': {
      type: Object,
      default: null,
    },
  },
  computed: {
    statusCode () {
      return (this.error && this.error.statusCode) || 404
    },
    message () {
      return this.error.message || 'This page could not be found'
    },
  },
}
</script>

<style lang="stylus" scoped>
.error-page {
  background-color: #f7f8fb;
  width: 100%;
  padding: 100px 60px;
  text-align: center;
  .error-img {
    max-width: 70%;
    max-height: 50%;
  }
}
</style>
